/*
 * RIDECLOUD — Vehicles Catalogue Page
 * Full catalogue with filter/sort sidebar at /vehicles
 */

import Navbar from "@/components/Navbar";
import VehicleCatalogue from "@/components/VehicleCatalogue";
import Footer from "@/components/Footer";

export default function Vehicles() {
  return (
    <div className="min-h-screen" style={{ background: "#f8f7fa" }}>
      <Navbar />
      <VehicleCatalogue />
      <Footer />
    </div>
  );
}
